import ozBuyingPowerBanner from '@/components/oz-buying-power-ldp/oz-buying-power-banner/oz-buying-power-banner.vue'
import ozBuyingPowerCalculator from '@/components/oz-buying-power-ldp/oz-buying-power-calculator/oz-buying-power-calculator.vue'
import ozBuyingPowerResult from '@/components/oz-buying-power-ldp/oz-buying-power-result/oz-buying-power-result.vue'
import ozBuyingPowerCreditBanner from '@/components/oz-buying-power-ldp/oz-buying-power-credit-banner/oz-buying-power-credit-banner.vue'
import { finCalcPotencialPageView } from './buying-power.tracker'

export default {
  name: 'home',
  components: {
    ozBuyingPowerBanner,
    ozBuyingPowerCalculator,
    ozBuyingPowerResult,
    ozBuyingPowerCreditBanner,
  },
  mounted: () => {
    finCalcPotencialPageView()
  },
}
